import React from 'react';


import Outproduct from '../src/screen/mobile_outproduct';
import Herosection from '../src/screen/herosection';
import WhatWeDo from '../src/screen/what_we_do';
import DesktopOutProduct from '../src/screen/destop_outproduct';
import Footer from '../src/screen/footer';
import Slider from '../src/screen/slider';
import Slider_Mobile from '../src/screen/slider_mobile';
function Home() {
  
  return (
    <div className="bg-white text-gray-900 overflow-x-hidden">
      {/* Hero Section */}
      <Herosection />
      <WhatWeDo />
      {/* out product */}
      <DesktopOutProduct />
      {/* === Mobile Layout === */}
      <Outproduct />
      {/* Products Section destop */}
      <Slider/>
      {/* Products Section mobile */}
      <Slider_Mobile/>
      {/* Footer */}
      <Footer />
    </div>
  );
}
export default Home;